import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import GoogleSignInButton from '../GoogleSignInButton/GoogleSignInButton';
import './Login.css';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login, loginWithGoogle } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(email, password);
            navigate('/admin');
        } catch (err) {
            setError(err.message || 'Přihlášení se nezdařilo');
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleCredential = async ({ credential }) => {
        setError('');
        setLoading(true);
        try {
            await loginWithGoogle(credential);
            navigate('/admin');
        } catch (err) {
            setError(err.message || 'Přihlášení přes Google se nezdařilo');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2>Přihlášení</h2>
                {error && <div className="login-error">{error}</div>}
                <label htmlFor="email">Email</label>
                <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                />
                <label htmlFor="password">Heslo</label>
                <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="current-password"
                />
                <button type="submit" disabled={loading}>
                    {loading ? 'Přihlašuji...' : 'Přihlásit se'}
                </button>
                <div className="auth-divider"><span>nebo</span></div>
                <GoogleSignInButton onCredential={handleGoogleCredential} />
                <p className="login-link">
                    <Link to="/forgot-password">Zapomněli jste heslo?</Link>
                </p>
                <p className="login-link">
                    Nemáte účet? <Link to="/registrace">Zaregistrujte se</Link>
                </p>
            </form>
        </div>
    );
}

export default Login;
